module.exports = __webpack_public_path__ + "B_right_click.aa4199e0.png";